<template>
  <div>
    <b-modal id="importModal" size="lg" @close="reset" @shown="modalShown" @hidden="modalHidden">
        <div class="loading_page" v-if="operations > 0">
        <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'" />
        </div>

        <slot name="form" :request=request :errors=errors :disabled="batchId != null"></slot>

        <b-row class="mt-2 mb-0">
          <b-col md="12">
            <b-form-group :label="$t('Import File')">
              <b-form-file
                  :disabled="batchId != null"
                  class="w-100 mb-2"
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  @input="(f)=> file = f"
                  :browse-text="$t('Xlsx File')"
              />
              <small v-if="('file' in errors)" class="text-danger">
                {{ $t(errors['file'][0]) }}
              </small>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row class="mt-2 mb-0 justify-content-md-center" v-if="batchId != null">
            <div class="d-flex justify-content-between align-items-center mt-2 w-75">
                  <div v-for="info in infoList" class="card mb-0 box-shadow">
                      <div class="card-header p-0 mx-1 mt-1 align-items-center justify-content-center">
                          <p class="font-weight-normal" >{{ $t(info.title) }}</p>
                      </div>
                      <div class="card-body text-center">
                          {{ info.count + ' ' + (info.percentage != undefined ? `(${info.percentage.toFixed(1)}%)` : '')}}
                      </div>
                  </div>
            </div>

            <!-- <b-col md="12" sm="12" lg="6" class="mb-1 mt-3">
              <label>{{ $t('Status') }}</label>
              <b-form-select
                  :v-model="statusFilter" 
                  :options="[{id: 'all', label: $t('All')}, ...infoList.filter((o)=> o.title != 'Total').map((o) => ({ id: o.title, label: $t(o.title) }))]"
                  class="w-100"
                  :reduce="val => val.id" 
                />
            </b-col> -->

            <b-table 

              :per-page="perPage"
              :current-page="currentPage"
              bordered
              responsive
              show-empty
              class="mt-2"
              :tbody-tr-class="(item, type)=> {
                if (!item || type !== 'row') return
                return 'statusTableRow statusTable' + item.status
              }"
              :items="importsList"
              :fields="[
                {
                  key:'number',
                  label:$t('Row'),
                  sortable:true
                },
                {
                  key:'status',
                  label:$t('Status'),
                  sortable:true
                },
                {
                  key:'reason',
                  label:$t('Reason'),
                  sortable:true
                }
              ]"
            >
            <template #cell(status)="data">
              {{  $t(data.item.status) }}
            </template>

            <template #cell(reason)="data">
              {{  $t(data.item.reason) }}
            </template>
          
          
          </b-table>

          <div class="mx-2 mb-2">
            <b-row>
              <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
                <b-pagination v-model="currentPage" :total-rows="infoList[0].count" :per-page="perPage" first-number last-number
                  class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
                  <template #prev-text>
                    <feather-icon icon="ChevronLeftIcon" size="18" />
                  </template>
                  <template #next-text>
                    <feather-icon icon="ChevronRightIcon" size="18" />
                  </template>
                </b-pagination>
              </b-col>

            </b-row>
        </div>


        </b-row>

      <template #modal-footer="{close}">
        <b-button :disabled="batchId != null || operations > 0" @click="downloadTemplate()">
          {{ $t('Download Template') }}
        </b-button>
        <b-button :disabled="batchId != null || operations > 0" @click="importFile()">
          {{ $t('DIALOGUE_SUBMIT_LABEL') }}
        </b-button>
      </template>
      </b-modal>
  </div>

</template>

<script>

import { OrbitSpinner } from 'epic-spinners'
import {
  BButton, 
  BCol, 
  BForm, 
  BFormGroup, 
  BFormInput, 
  BInputGroup, 
  BRow,
  BModal ,
  BTable, 
  BFormFile,
  BBadge,
  BPagination,
  BFormSelect
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import axios from '@/libs/axios'
import { eventBus } from '@/main'

export default {
  name: 'ModelImport',
  components: {
    BRow, 
    BCol, 
    BTable,
    BFormGroup, 
    BFormInput, 
    BInputGroup, 
    BForm, 
    BFormFile,
    BButton, 
    BModal,
    OrbitSpinner,
    BBadge,
    BPagination,
    BFormSelect
  },
  props:{
    model:{
      type:String
    }
  },
  setup(props, {root}) {

    var importsRenderTimer = undefined
    var imports = {}
    var info = {
      'Total':0,
      'Pending':0,
      'UnderProcess':0,
      'Success':0,
      'Failed':0
    }

    class ImportRow {
        constructor(number, status='Pending', reason=''){
          this.number = number
          this.status = status
          this.reason = reason
        }

        setStatus(newStatus, reason){

          if(['Pending', 'Success', 'Failed'].includes(this.status)){
            info[this.status]--
          }else{
            info['UnderProcess']--
          }

          if(['Pending', 'Success', 'Failed'].includes(newStatus)){
            info[newStatus]++
          }else{
            info['UnderProcess']++
          }


          this.status = newStatus
          this.reason = reason ?? ''

        }

    }


    const operations = ref(0)
    const request = ref({})
    const file = ref(null)
    const errors = ref({})
    const batchId = ref(null)
    const importsList = ref([])
    const currentPage = ref(1)
    const perPage = ref(10)
    const infoList = ref([])
    const statusFilter = ref('all')

    
    const importFile = () => {

      errors.value = {}
      operations.value++

      let data = new FormData();

      data.append('file', file.value)
      data.append('model', props.model)

      for (const [key, value] of Object.entries(request.value)) {
        data.append(key, value)
      }

      axios.post('import', data, { headers:{ 'Content-Type': 'multipart/form-data'}})
      .then((res)=> {
        
        batchId.value = res.data.batchId

        imports = {}

        info['Total'] = res.data.rows
        info['Pending'] = res.data.rows

        for(let rowNumber=1; rowNumber <= res.data.rows; rowNumber++ ){
          imports[rowNumber] = new ImportRow(rowNumber)
        }

        renderImports()

      })
      .catch((error)=> {
        errors.value = error.response.data.errors
      })
      .finally(()=> {
        operations.value--
      })

    }

    const reset = () => {
      batchId.value = null
      imports = {}
      info = {
      'Total':0,
      'Pending':0,
      'UnderProcess':0,
      'Success':0,
      'Failed':0
      }
      importsList.value = []
      request.value = {}
    }

    const downloadTemplate = ()=> {
      operations.value++
      axios.get('import/template', {params:{ model:props.model}, responseType: 'blob'})
          .then( res => {
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(new Blob([res.data], { type: res.headers['content-type'], encoding: 'UTF-8' }))
            link.download = `${props.model}-import-template.xlsx`
            link.click()
          })
          .catch( err => console.log(err))
          .finally(()=> operations.value-- )
    }

    const renderImports = () => {
      importsList.value = Object.values(structuredClone(imports))
      infoList.value = Object.keys(info).map((name)=> {
            return {
              title:name,
              count:info[name],
              ...(name !== 'Total' && {percentage: (info[name] / info['Total']) * 100})
            }
        })
        console.log('imports rendered')
    }

    const modalShown = () => {
      eventBus.$on('importUpdate', (message)=> {
        if(message.batchId == batchId.value){
          imports[message.rowNumber].setStatus(message.status, message.reason)
        }
      })
      importsRenderTimer = setInterval(() => renderImports(), 500);
    }

    const modalHidden = () => {
      eventBus.$off('importUpdate')
      clearInterval(importsRenderTimer)
    }

    // // debugging start

    // batchId.value = 'pwfjoiqwjfiowed'

    // let count = 5000

    // info['Total'] = count

    // info['Pending'] = count

    // for(let rowNumber=1; rowNumber <= count; rowNumber++ ){
    //     imports[rowNumber] = new ImportRow(rowNumber)
    // }

    // renderImports()

    // // debugging end


    return {
      modalShown,
      modalHidden,
      operations,
      request,
      file,
      errors,
      importFile,
      downloadTemplate,
      importsList,
      currentPage,
      perPage,
      batchId,
      reset,
      infoList,
      statusFilter
    }

  }
}
</script>

<style>

.statusTableRow {
  color: white;
  background-color: #999793;
}

.statusTablePending {
  background-color: #e6d7d5;
}

.statusTableSuccess {
  background-color: #83d487;
}

.statusTableFailed {
  background-color: #d9776c;
}

</style>
